import { render, staticRenderFns } from "./Malerier.vue?vue&type=template&id=a7b3d4c0&"
import script from "./Malerier.vue?vue&type=script&lang=js&"
export * from "./Malerier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports